import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import enJson from './locales/en/translation.json';
import esJson from './locales/es/translation.json';
import esArJson from './locales/es-ar/translation.json';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)

const resources = {
  en: {
    translation: { ...enJson }
  },
  es: {
    translation: { ...esJson }
  },
  esAr: {
    translation: { ...esArJson }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: {
      default: ['es']
    },
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
